import JJCStationView from '@/components/product/JJCStationView.vue'

export default [
  {
    path: '/product_station',
    name: 'JJCStationView',
    component: JJCStationView
  }
]
